import "babel-polyfill";
import React from 'react';
import { setCaretPosition } from './functions.js';
import TextEditorInput from './TextEditorInput.js';
// import "ie-array-find-polyfill";


class TextEditorBox extends React.Component {

    constructor(props) {
        super(props);

        this.handleContentLayerChange = this.handleContentLayerChange.bind(this);
        this.handlePerspectiveLayerSelect = this.handlePerspectiveLayerSelect.bind(this);
    }


    getMaxLinesCount()
    {
        let count = 1;
        
        if (this.props.perspective.designer_mode == 'resize')
        {
            count = 3;
            if (this.props.perspective.max_lines > 0)
                count = this.props.perspective.max_lines;
                
            if (this.props.activeDesignerVariants !== null && this.props.activeDesignerVariants !== undefined && this.props.activeDesignerVariants.length > 0)
            {
                for (var varI = 0; varI < this.props.activeDesignerVariants.length; varI++) {

                    if (this.props.activeDesignerVariants[varI].selectedVar === null || this.props.activeDesignerVariants[varI].selectedVar === undefined)
                        continue;

                    if (this.props.activeDesignerVariants[varI].selectedVar.max_lines > 0 && this.props.activeDesignerVariants[varI].selectedVar.max_lines < count)
                        count = this.props.activeDesignerVariants[varI].selectedVar.max_lines;
                }
            }
        }

        return count;
    }

    getMaxCharsCount()
    {
        let count = 60;
        
        if (this.props.perspective.max_chars > 0)
            count = this.props.perspective.max_chars;
            
        if (this.props.activeDesignerVariants !== null && this.props.activeDesignerVariants !== undefined && this.props.activeDesignerVariants.length > 0)
        {
            for (var varI = 0; varI < this.props.activeDesignerVariants.length; varI++) {

                if (this.props.activeDesignerVariants[varI].selectedVar === null || this.props.activeDesignerVariants[varI].selectedVar === undefined)
                    continue;

                if (this.props.activeDesignerVariants[varI].selectedVar.max_chars > 0 && this.props.activeDesignerVariants[varI].selectedVar.max_chars < count)
                    count = this.props.activeDesignerVariants[varI].selectedVar.max_chars;
            }
        }

        return count;
    }

    getTextLayer(line) {

        const layer = this.props.contentLayers.find((ly) => {
            return ly.type == 'text' && ly.rowIndex == line && ly.perspectiveId == this.props.perspective.id && ly.perspective_varid == this.props.perspective.varid;
        });

        return layer;
    }

    handleContentLayerChange(textLayer) {
        this.props.onContentLayerChange(textLayer);
    }

    handlePerspectiveLayerSelect(perspective, layer) {
        this.props.onPerspectiveLayerSelect(perspective, layer);
    }

    render() {

        const textInputs = [];
        for (var line = 0; line < this.getMaxLinesCount(); line++) {

            const textLayer = this.getTextLayer(line);

            textInputs.push(
                <TextEditorInput
                    key={textLayer.id + 'input'} 
                    contentLayer={textLayer}
                    activeDesignerVariants={this.props.activeDesignerVariants}
                    perspective={this.props.perspective}
                    onContentLayerChange={this.handleContentLayerChange}
                    onPerspectiveLayerSelect={this.handlePerspectiveLayerSelect}
                />
            );
        }

        return (
            <div className="text_editor_box row">
                <strong>Texteingabe:</strong>
                <br />
                {textInputs}
            </div>
        );
    }
}
export default TextEditorBox;



// WEBPACK FOOTER //
// ./src/TextEditorBox.js